export default "/app/global-wrapper-client/static/07e1a48adec2197fb604c01538ebc4ed.woff";